module.exports = __webpack_public_path__ + "assets/img/38000-centrifuge-on-stand.6b7e0a80.jpg";